// extracted by mini-css-extract-plugin
module.exports = {"counter":"Counter_counter___SG0z","value":"Counter_value__1HeHa"};